(() => {
  var CartTimerApp = (() => {
    const TIMER_KEY = "reservation_timer_end";
    const RESERVATION_DURATION_MINUTES = 10;
  
    var runCountdown = () => {
      setInterval(() => {
        let endTime = localStorage.getItem(TIMER_KEY);
  
        if (!endTime) {
          return;
        }

        endTime = parseInt(endTime, 10);

        const timerElement = document.querySelector("[js-cart-drawer-timer]");
        if (!timerElement) return;
        const now = Date.now();
        const remaining = endTime - now;
  
        if (remaining <= 0) {
          timerElement.style.display = 'none';
          localStorage.removeItem(TIMER_KEY);
          return;
        }

        timerElement.style.display = 'flex';
  
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
  
        if (timerElement.querySelector('[data-template]')) {
          timerElement.querySelector('[data-template]').innerText = String(timerElement.querySelector('[data-template]').getAttribute('data-template')).replace('((value))', `${pad(minutes)}:${pad(seconds)}`);
        }
      }, 3);
    }
  
    var pad = (n) => {
      return n < 10 ? '0' + n : n;
    }

    var initialize = () => {
      let endTime = localStorage.getItem(TIMER_KEY);

      if (!endTime) {
        const now = new Date();
        now.setMinutes(now.getMinutes() + RESERVATION_DURATION_MINUTES);
        endTime = now.getTime();
        localStorage.setItem(TIMER_KEY, endTime);
      }

      runCountdown();
    }
    return {
      init: initialize
    }
  })();

  var CartDrawerUpsellApp = (() => {
    var initialize = () => {
      // Function to perform your action
      function handleUpsellAppear(element) {
        console.log('Upsell product list appeared in viewport!');
        const f = new Flickity(element, {
          cellAlign: "left", contain: true, prevNextButtons: true, pageDots: false, resize: true
        });
        setTimeout(() => {
          f.resize();
          element.querySelectorAll('[js-cart-drawer-upsell-product] [js-atc]').forEach(productWrapper => {
            productWrapper.addEventListener('click', () => {
              atc(productWrapper.closest('[js-cart-drawer-upsell-product]'));
            });
          });
        });
      }

      // Create Intersection Observer to detect when element enters viewport
      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            handleUpsellAppear(entry.target);
            // Optional: stop observing after first appearance
            // intersectionObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1, // Trigger when 10% of element is visible
        rootMargin: '0px'
      });

      // Function to check and observe the element
      function observeUpsellList() {
        const upsellElement = document.querySelector('.upsell-product-list');
        
        if (upsellElement && !upsellElement.dataset.observed) {
          upsellElement.dataset.observed = 'true'; // Prevent multiple observations
          intersectionObserver.observe(upsellElement);
          console.log('Started observing upsell element');
        }
      }

      // Mutation Observer to watch for element being added to DOM
      const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          observeUpsellList();
        });
      });

      // Start observing DOM changes
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Also check immediately in case element already exists
      observeUpsellList();
    }
    var atc = async (container) => {
      if (!container) return;
      let variant_id = container.getAttribute('data-variant-id');
      if (container.querySelector('[js-variant-select]')) {
        variant_id = container.querySelector('[js-variant-select]').value;
      }
      container.classList.add('loading');

      const tempForm = Object.assign(document.createElement('form'), {
        innerHTML: `<input type="hidden" name="id" value="${variant_id}"><input type="hidden" name="quantity" value="1">`
      });

      ajaxCart.addCartItem(tempForm);
      return;
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });

      const responseJson = await response.json();

      if (response.ok) {
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];

        ajaxCart.updateCartPage(responseJson);

        container.classList.remove('loading');
      } else {
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"] || "Unknown error"
          }
        }));

        ajaxCart.load();
      }
    }
    return {
      init: initialize
    }
  })();

	var App = (() => {
    var initialize = () => {
      CartTimerApp.init();
      CartDrawerUpsellApp.init();
    }
    
    return {
      init: initialize
    }
  })();
  
  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });
})();